// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".landing-graph .apexcharts-tooltip{background:red!important;background-color:var(--background-color-base)!important;border:none!important;border-radius:4px;-webkit-box-shadow:none!important;box-shadow:none!important;color:var(--color-text-primary)!important;z-index:111}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
